import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Close16 } from 'ui/icons/action/Close16';
import { useIsFirstCondition, useRemoveCondition } from '../../../hooks/form';

export const testIds = {
  button: 'dcb-delete-button',
};

export const DeleteConditionButton = () => {
  const onDelete = useRemoveCondition();
  const isFirstCondition = useIsFirstCondition();

  if (isFirstCondition) return null;

  return (
    <IconButton data-test={testIds.button} onClick={onDelete} variant={BUTTON_VARIANTS.GHOST}>
      <Close16 />
    </IconButton>
  );
};
